module.exports = __webpack_public_path__ + "static/13-b8ae39b567a32c05ef8130aa70e5f548.svg";